import { graphql } from '@/gql';

export const CREATE_BEWERTUNG = graphql(`
  mutation mitarbeiter_createRotationsplanBewertung(
    $input: mitarbeiter_createRotationsplanBewertungInput!
  ) {
    mitarbeiter_createRotationsplanBewertung(input: $input) {
      success {
        bewertung {
          id
          sterne
          beurteilung
        }
      }
      error {
        message
      }
    }
  }
`);
